import { useCallback, useState } from "react";
import { apiURL } from "../../../utils/constant";
import Api from "../../../utils/api.utils";
import { useDispatch, useSelector } from "react-redux";
import { getApiData } from "../../selector/auth.selector";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";
import { getLanguageNumber } from "../../selector/language.selector";

export default function useInstruction() {
  const [Instructions, setInstructions] = useState([]);
  const apidata = useSelector(getApiData);
  const number = useSelector(getLanguageNumber);
  const subjectId = apidata?.SubjectId;
  const dispatch = useDispatch();
  const fetchInstruction = useCallback(async () => {
    try {
      dispatch(showPageLoader());
      const { data } = await Api.get({
        url: apiURL.instruction(),
        params: {
          SubjectId: subjectId,
        },
      });
      setInstructions(data[0]);
      dispatch(hidePageLoader());
      //   return data;
    } catch (error) {
      dispatch(hidePageLoader());
      console.log("error==>", error);
    }
  }, [number]);
  return { Instructions, fetchInstruction };
}
